import { render, staticRenderFns } from "./CarAccidentList.vue?vue&type=template&id=02210aab&scoped=true&"
import script from "./CarAccidentList.vue?vue&type=script&lang=js&"
export * from "./CarAccidentList.vue?vue&type=script&lang=js&"
import style0 from "./CarAccidentList.vue?vue&type=style&index=0&id=02210aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02210aab",
  null
  
)

export default component.exports